import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import api from '../api';
import UserForm from '../components/UserForm';
import {Container} from '@mui/material';

const Register = ({setAuth}) => {
    const navigate = useNavigate();

    const handleSubmit = async (processedData) => {
        try {
            const response = await api.post('/api/accounts/register/', processedData);
            localStorage.setItem('token', response.data.token);
            setAuth(true);
            navigate('/profile');
        } catch (error) {
            if (error.response) {
                console.error('Registration failed:', error.response.data);
                // Here you could pass an onError callback to UserForm to display API errors
            } else if (error.request) {
                console.error('Registration failed: No response from server.', error.request);
            } else {
                console.error('Registration failed: Error', error.message);
            }
        }
    };

    // The initial data for a new registration is mostly empty
    const initialFormData = {
        email: '',
        first_name: '',
        last_name: '',
        year_of_birth: null,
        country_of_residence: '',
        zip_code: '',
        region: '',
        gender: '',
        height_mm: null,
        weight_g: null,
        job: null,
        yearly_income_cents: null,
        relationship_status: '',
    };

    return (
        <Container maxWidth="md">
            <UserForm
                formData={initialFormData}
                handleSubmit={handleSubmit}
                isRegister={true}
                formTitle="Register New Account"
            />
        </Container>
    );
};

export default Register;
